/**
 *Created by jmmartinez on 3/8/18
 *  v.1.1  28/03/2019 Añadido tipo "PREGUNTA. Añadidos prop onAccept y botones aceptar/cancelar para las preguntas.
 **/

import React from 'react'
import { Dialog, Tooltip, Button } from "@blueprintjs/core";
import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/icons/lib/css/blueprint-icons.css";
import PropTypes from 'prop-types';
import {Classes} from "@blueprintjs/core/lib/esm/index";


class Dialogo extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            titulo: props.titulo,
            mensaje: props.mensaje,
            tipo: props.tipo,
        }
    }

    componentDidMount() {
        const {titulo, mensaje, tipo} = this.props;
        this.setState({titulo: titulo, mensaje: mensaje, tipo: tipo});
    }

    componentWillReceiveProps(newProps) {
        const {titulo, mensaje, tipo} = this.state;
        const newState = {};
        if (newProps.titulo !== titulo) {
            newState.titulo = newProps.titulo;
        }
        if (newProps.mensaje !== mensaje) {
            newState.mensaje = newProps.mensaje;
        }
        if (newProps.tipo !== tipo) {
            newState.tipo = newProps.tipo;
        }
        if (Object.keys(newState).length > 0) {
            this.setState(newState);
        }
    }

    onClose= () => {
        console.log("onClose");
        const {onClose} = this.props;
        this.setState({mensaje: null});
        onClose && onClose();
    }

    onQuestion= (respuesta) => {
        const {onQuestion} = this.props;
        this.setState({mensaje: null});
        onQuestion && onQuestion(respuesta);
    }

    render() {
        const {mensaje, tipo, titulo} =  this.state;
        const {onQuestion} = this.props;
        let tituloTransformado= titulo ? titulo : ""; //PAra evitar el warning con icon
        let icon= "info-sign";
        let color= "#dddddd";
        switch (tipo){
            case "INFORMACION": icon= "info-sign"; color= "#dddddd"; break;
            case "EXITO": icon= "tick-circle"; color="#b2ddc6"; break;
            case "ERROR": icon= "error"; color="#F8B87D"; break;
            case "PREGUNTA": icon= "help"; color="#ffffff"; break;
            default: icon= "info-sign"; color= "#dddddd"; break;
        }
        return (
            <Dialog icon={icon}
                    title={tituloTransformado}
                    onClose={this.onClose}
                    isOpen={mensaje && mensaje !== ""}
                    usePortal= {true}
                    style={{ width: "60%", backgroundColor: color}}
            >
                <div className={Classes.DIALOG_BODY}>
                    {mensaje}
                </div>
                <div className={Classes.DIALOG_FOOTER}>
                    {!onQuestion &&
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Tooltip content="Cerrar">
                                <Button onClick={this.onClose}>Cerrar</Button>
                            </Tooltip>
                        </div>
                    }
                    {onQuestion &&
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Tooltip content="Aceptar">
                                <Button onClick={() => this.onQuestion(true)}>Aceptar</Button>
                            </Tooltip>
                            <Tooltip content="Cancelar">
                                <Button onClick={() => this.onQuestion(false)}>Cancelar</Button>
                            </Tooltip>
                        </div>
                    }
                </div>
            </Dialog>
        );
    }
}


Dialogo.propTypes = {
    titulo: PropTypes.string,
    mensaje: PropTypes.string,
    tipo: PropTypes.string,
    onClose: PropTypes.func,
    onQuestion: PropTypes.func,
}

export default Dialogo

